import { createStyles, makeStyles } from "@material-ui/styles";

import { RelodeTheme } from "../../..";

export const useClasses = makeStyles((theme: RelodeTheme) =>
    createStyles({
        attachmentContainer: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: theme.spacing(2),
        },
        attachmentRemovalButton: {
            marginLeft: theme.spacing(2),
        },
        bestReachOptions: {
            width: 500,
        },
        formattedResumeUploadLabel: {
            display: "flex",
            flexDirection: "column",
            marginLeft: theme.spacing(1),
        },
        formattedResumeUploadButton: {
            margin: theme.spacing(4, 0),
        },
        formWrapper: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: theme.spacing(4, 3),
            width: "100%",
            [theme.breakpoints.down("md")]: {
                padding: theme.spacing(2, 1, 0, 1),
            },
        },
        helperText: {
            color: theme.palette.error.main,
        },
        input: {
            margin: theme.spacing(1, 4, 1, 0),
            width: "95%",
            [theme.breakpoints.down("md")]: {
                margin: theme.spacing(1, 0, 1, 0),
                width: "100%",
            },
        },
        inputLg: {
            width: "100%",
        },
        inputMd: {
            width: `calc(66.6% - ${theme.spacing(2)}px)`,
        },
        inputSm: {
            width: 208,
        },
        jobDetailsGroup: {
            marginLeft: theme.spacing(4),
            marginRight: theme.spacing(4),
            marginBottom: theme.spacing(4),
        },
        leftSection: {
            display: "flex",
            flexBasis: "50%",
            height: "100%",
        },
        message: {
            alignSelf: "center",
            marginTop: theme.spacing(2),
        },
        mobileVerificationLabel: {
            marginBottom: theme.spacing(1),
        },
        radioControl: {},
        radioForm: {
            margin: 0,
        },
        radioGroup: {
            marginTop: theme.spacing(1),
        },
        relocationSwitch: {
            display: "block",
            marginRight: theme.spacing(5),
        },
        relocationSwitches: {
            display: "flex",
            width: 600,
        },
        resumeLink: {
            margin: theme.spacing(1.5, 0, 0, 0),
            width: "100%",
        },
        resumeInput: {
            display: "none",
        },
        resumeNeededDialogTitle: {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
        },
        warning: {
            padding: `${theme.spacing(2)}px ${theme.spacing(
                2
            )}px 0 ${theme.spacing(2)}px `,
            [theme.breakpoints.down("md")]: {
                padding: 0,
            },
        },
        rightSection: {
            display: "flex",
            flexBasis: "50%",
            flexGrow: 1,
            flexShrink: 0,
            marginLeft: theme.spacing(3),
        },
        salaryLayout: {
            display: "grid",
            gridTemplateColumns: "220px 220px 220px",
            gridColumnGap: theme.spacing(2),
            gridRowGap: theme.spacing(2),
        },
        scheduleTagList: {
            marginTop: 0,
        },
        travelTagList: {
            marginTop: 0,
        },
        wizardContentArea: {
            display: "flex",
            flexBasis: "50%",
            flexDirection: "column",
        },
        wizardFormContentArea: {
            background: theme.palette.background.default,
            border: 5,
            display: "flex",
            flexBasis: "100%",
            flexDirection: "column",
            overflow: "auto",
            [theme.breakpoints.down("md")]: {
                background: theme.palette.background.paper,
                padding: theme.spacing(2, 0),
            },
        },
        wizardFullContentArea: {
            display: "flex",
            flexBasis: "100%",
            flexGrow: 1,
            justifyContent: "center",
        },
        wizardToggleControlBar: {
            alignSelf: "center",
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(3),
        },
        label: {
            color: theme.relode.colors.label.main,
        },
        checkboxContainer: {
            marginLeft: theme.spacing(1),
        },
        checkBox: {
            [theme.breakpoints.down("md")]: {
                marginBottom: theme.spacing(2),
                minHeight: "25%",
            },
        },
        previewContainer: {
            background: theme.palette.background.default,
            display: "flex",
            margin: theme.spacing(3),
            padding: theme.spacing(3, 0),
        },
        smsPaper: {
            margin: `${theme.spacing(4)}px auto`,
            padding: theme.spacing(4, 0),
            maxWidth: "50%",
            minHeight: "90%",
            display: "flex",
            flexDirection: "column",
        },
        smsContent: {
            background: theme.palette.background.default,
            marginLeft: theme.spacing(2),
            padding: theme.spacing(2),
            maxWidth: "80%",
            borderRadius: "8px",
        },
        smsTime: {
            color: theme.relode.colors.label.main,
            margin: "0 auto",
        },
        paper: {
            margin: "0 auto",
            padding: theme.spacing(4, 3),
            maxWidth: "80%",
        },
        relodeLogo: {
            margin: theme.spacing(4, 0),
            display: "flex",
            justifyContent: "center",
        },
        header: {
            marginBottom: theme.spacing(5),
        },
        text: {
            marginBottom: theme.spacing(3),
        },
        textWrapper: {
            marginTop: theme.spacing(4),
        },
        emailContent: {
            padding: theme.spacing(4, 3, 1, 3),
            background: theme.palette.background.default,
        },

        section: {
            marginBottom: theme.spacing(1),
            flex: 1,
        },
        emailGroup: {
            display: "flex",
            flexDirection: "row",
        },
        emailButtons: {
            display: "grid",
            gridGap: theme.spacing(1),
            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            marginBottom: theme.spacing(3),
        },
        redButton: {
            color: theme.relode.colors.negativeAction.contrastText,
            backgroundColor: theme.relode.colors.negativeAction.main,
            "&:hover": {
                backgroundColor: theme.relode.colors.negativeAction.dark,
            },
        },
        footer: {
            margin: `${theme.spacing(4)}px 0`,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
        },
        logoFooter: {
            marginBottom: theme.spacing(4),
        },
        social: {
            display: "flex",
            justifyContent: "center",
            "& img": {
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2),
            },
        },
        dummyButton: {
            pointerEvents: "none",
        },
        preserve: {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        },
    })
);
